var accessTokenKey = "accessToken";
var correlationIdKey = "correlationId";
var clientKey = "client";
var givenNameKey = "givenName";
var idTokenKey = "idToken";
var selectedIdKey = "selectedAccountId";
var languageKey = "language";
var profileSessionActionKey = "profile-mfe-action";
export var setProfileCorrelationId = function (id) {
    sessionStorage.setItem(correlationIdKey, id);
};
export var getProfileCorrelationId = function () {
    return sessionStorage.getItem(correlationIdKey);
};
export var getProfileClient = function () {
    var client = localStorage.getItem(clientKey);
    return client || "";
};
export var setProfileClient = function (client) {
    localStorage.setItem(clientKey, client);
};
export var getProfileAccessToken = function () {
    return sessionStorage.getItem(accessTokenKey);
};
export var getProfileGivenName = function () {
    return sessionStorage.getItem(givenNameKey);
};
export var removeProfileAccessToken = function () {
    sessionStorage.removeItem(accessTokenKey);
};
export var setProfileSelectedId = function (id) {
    sessionStorage.setItem(selectedIdKey, id);
};
export var getProfileSelectedId = function () {
    return sessionStorage.getItem(selectedIdKey);
};
export var setProfileGivenName = function (name) {
    sessionStorage.setItem(givenNameKey, name);
};
export var setProfileIdToken = function (id) {
    sessionStorage.setItem(idTokenKey, id);
};
export var setProfileLanguage = function (language) {
    localStorage.setItem(languageKey, language);
};
export var getProfileLanguage = function () {
    return localStorage.getItem(languageKey);
};
export var setProfileSessionAction = function (action) {
    sessionStorage.setItem(profileSessionActionKey, action);
};
export var getProfileSessionAction = function () {
    return sessionStorage.getItem(profileSessionActionKey);
};
export var removeProfileSessionAction = function () {
    sessionStorage.removeItem(profileSessionActionKey);
};
